//All part of this file is related to
//https://en.wikipedia.org/wiki/Levenshtein_distance
export const compute = (a : string, b : string) : number => {
	if (a.length === 0) {
		return (b.length);
	}
	if (b.length === 0) {
		return (a.length);
	}
	const matrix = new Array(b.length + 1);
	let i;
	for (i = 0; i <= b.length; i++) {
		matrix[i] = [i];
	}
	let j;
	for (j = 0; j <= a.length; j++) {
		matrix[0][j] = j;
	}
	for (i = 1; i <= b.length; i++) {
		for (j = 1; j <= a.length; j++) {
			if (b.charAt(i-1) == a.charAt(j-1)) {
				matrix[i][j] = matrix[i-1][j-1];
			} else {
				matrix[i][j] = Math.min(
					matrix[i - 1][j - 1] + 1, // substitution
					Math.min(
						matrix[i][j - 1] + 1, // insertion
						matrix[i - 1][j] + 1  // deletion
					)
				);
			}
		}
	}
	return (matrix[b.length][a.length]);
};
export const findBest = (
	reference  : string,
	datasource : string[],
	accuracity : number
) => {
	const best = findAllBestRaw(reference, datasource, accuracity).reduce(
		(
			a,
			c
		) => {
			if (a === null) {
				return (c);
			}
			return ((a.dist < c.dist) ? a : c);
		},
		<ReturnType<typeof findAllBestRaw>[0] | null>null
	);
	return (best ? best.source : null);
};
export const findAllBestRaw = (
	reference        : string,
	datasource       : string[],
	accuracity       : number
) => {
	var results = datasource.map(x => ({
		source : x,
		dist   : compute(x, reference)
	}));
	var maxdist = reference.length / accuracity;
	return (results.filter(x => x.dist < maxdist));
};
export const findAllBest = (
	reference        : string,
	datasource       : string[],
	accuracity       : number
) => {
	return (findAllBestRaw(reference, datasource, accuracity).map(x => x.source));
};
